<template>
  <div>
    <b-modal
      size="lg"
      v-model="visible"
    >
    <template slot="modal-title">
      {{titulo}}
    </template>

      <div>
        <b-row>
          <b-col lg="12">
            <b-form>
              <b-card-body>
                <b-row>
                  <b-col sm="6">
                    <!-- id -->
                    <b-form-group label="Código">
                      <b-form-input
                        id="acvcodigo"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.acvcodigo"
                        :disabled="campoBloqueado('acvcodigo', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_condvta', 'acvcodigo', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.acvcodigo }}
                      </span>
                    </b-form-group>

                    <b-form-group label="Tipo">  
                       <b-form-input
                        id="acvtipo"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.acvtipo"
                        :disabled="campoBloqueado('acvtipo', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_condvta', 'acvtipo', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.acvtipo }}
                      </span>
                    </b-form-group>
                 </b-col>
          
                   <b-col sm="12">  
                    <!-- lineas de negocio -->
                    <b-form-group label="Descripción">
                      <b-form-textarea
                        id="acvdescrip"
                        type="text"
                        placeholder=""
                        rows="4"
                        size="xl"
                        max-rows="5"
                        v-model="datosFormulario.acvdescrip"
                        :disabled="campoBloqueado('acvdescrip', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_condvta', 'acvdescrip', $event, 'datosFormulario')">
                      </b-form-textarea>
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.acvdescrip }}
                      </span>
                    </b-form-group>

                  </b-col>
                  </b-row>
              </b-card-body>
            </b-form>
          </b-col>
        </b-row>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <p class="float-left"></p>
        <b-button
          type="submit"
          variant="secondary"
          class="float-right"
          @click="modalEditarCondicion = false; visible = false;"
        ><i class="fa fa-close"></i> Cerrar</b-button>
        <b-button
          type="submit" 
          variant="primary"
          class="float-right"
          style="margin-right:8px;"
          @click="guardarCondicion"
        ><i class="fa fa-save"></i> Guardar</b-button>
      </div>
    </b-modal>
  
    <seleccionar-sujeto
      ref="refSeleccionarSujeto"
      @sujetoSeleccionado="sujetoSeleccionado($event)"
    ></seleccionar-sujeto>
  </div>
</template>
<script>

import axios from "axios";
import apiCondicionVenta from "../../components/services/apiCondicionVenta";
import { globalesMixin } from "../../components/mixins/globalesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import apiSeleccionarSujeto from "../../components/services/apiSeleccionarSujeto";
import SeleccionarSujeto from "../../components/global/SeleccionarSujeto";


export default {
  name: "EditarCondicion",
  mixins: [globalesMixin],
  data: function() {
    return {
      titulo: "",
      visible: false,
      modalEditarCondicion: false,
      modalAgregarCondicion: false,
      es: es,
      datosFormulario: {
        acvcodigo: "",
        acvtipo: "",
        acvdescrip: "",
        acvusumodif: "",
        acvfmodif: "",
        acvestado: ""
      },
      mensajeValidacionCampo: {}
    };
  },
  components: {
    Datepicker,
    SeleccionarSujeto
  },
  methods: {
    obtenerCondicion(mail, usuario, id, tiporec) {
      this.titulo = "Editar Condición de Venta";
      this.mensajeValidacionCampo = {};
      return apiCondicionVenta
        .buscar(mail, usuario, id, tiporec)
        .then(response => {

          this.datosFormulario.acvcodigo = "";
          this.datosFormulario.acvtipo = "";
          this.datosFormulario.acvdescrip = "";
          this.datosFormulario.acvusumodif = "";
          this.datosFormulario.acvfmodif = "";
          this.datosFormulario.acvestado = "";

          response.data = this.keysMinuscula(response.data);
          this.datosFormulario = response.data.res[0];
          this.datosFormularioEstado = response.data.festado;

          this.modalEditarCondicion= true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    pre_insertar(mail, usuario, p_acvcodigo) {
      this.titulo = "Agregar Condición";
      this.mensajeValidacionCampo = {};
      return apiCondicionVenta
        .pre_insertar(mail, usuario, p_acvcodigo)
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          this.datosFormulario.acvcodigo = "";
          this.datosFormulario.acvtipo = "";
          this.datosFormulario.acvdescrip = "";
          this.datosFormulario.acvusumodif = "";
          this.datosFormulario.acvfmodif = "";
          this.datosFormulario.acvestado = "";
      
          this.datosFormulario.acvusumodif = response.data.res[0].acvusumodif;
          this.datosFormulario.acvestado = response.data.res[0].acvestado;
          this.datosFormulario.acvfmodif = response.data.res[0].acvfmodif;

          this.datosFormularioEstado = response.data.festado;

          this.modalAgregarCondicion = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    guardarCondicion(event) {
      event.preventDefault();
      this.$Progress.start();
      
      if (this.modalEditarCondicion){
        return apiCondicionVenta
        .modificar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaCondicion");
            this.modalEditarProveedor = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else if (this.modalAgregarCondicion) {
        return apiCondicionVenta
        .insertar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaCondicion");
            this.modalAgregarCondicion = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

      
    },
    seleccionarSujeto(titulo, tipoBusqueda) {
      this.$refs.refSeleccionarSujeto.modalSujeto = true;
      this.$refs.refSeleccionarSujeto.tituloModal = titulo;
      this.$refs.refSeleccionarSujeto.busqueda = "";
      this.$refs.refSeleccionarSujeto.data = [];
      this.$refs.refSeleccionarSujeto.tipoBusqueda = tipoBusqueda;
      this.$refs.refSeleccionarSujeto.accion = "descripcion";
      this.$refs.refSeleccionarSujeto.textoAccion = "Descripcion";
      
      this.$refs.refSeleccionarSujeto.tipo = "CLI";
      
    },
    sujetoSeleccionado(event) {
      this.$refs.refSeleccionarSujeto.modalSujeto = false;
      if (event.tipoBusqueda == "seleccionarSujeto") {
        this.datosFormulario.acvcodigo = event.acvcodigo;
        this.datosFormulario.acvtipo = event.acvtipo;
        
      }
      
      
    },
  }
};
</script>
<style scoped>
</style>